import { render, staticRenderFns } from "./tiscButton.vue?vue&type=template&id=21241c40&"
import script from "./tiscButton.vue?vue&type=script&lang=js&"
export * from "./tiscButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports